// tslint:disable:max-classes-per-file
import BetModel from "../../../../vendor_core/core/src/model/BetModel";
import debugModel from "../../../../vendor_core/core/src/model/DebugModel";
import GameModel from "../../../../vendor_core/core/src/model/GameModel";
import { IRequestBuilder } from "../../../../vendor_core/core/src/server/requests/RequestBuilder";
import VendorModel from "../../../../vendor_core/server/model/VendorModel";
import SpinModel from "../../../../vendor_core/core/src/model/SpinModel";
import ConsoleUtil from '../../../../vendor_core/core/src/utils/ConsoleUtil';
import BuyFeatureModel from '../../../../vendor_core/core/src/model/BuyFeatureModel';
import ConfigManager from '../../../../vendor_core/core/src/managers/ConfigManager';
import { ConfigurationTypes } from '../../../../vendor_core/core/src/const/ConfigurationTypes';
import IVendorClientConfigRequestData from '../../../../vendor_core/server/requests/contracts/IVendorClientConfigRequestData';
declare const DEBUG: boolean;
export class BBLoginRequest implements IRequestBuilder {
  get method() {
    return "POST";
  }

  get path() {
    return ConfigManager.getConfig<IVendorClientConfigRequestData>(ConfigurationTypes.GAME).clientConfig.gameServerApi + "/rmlogin";
  }

  get requestData() {
    let requestParams = {
      token: GameModel.playerToken,
      userid: GameModel.playerConfig.userId,
      mode: GameModel.mode,
      g: ConfigManager.getConfig(ConfigurationTypes.RELAX_SERVER).gameId,
      channel: GameModel.urlParams.channel || "web",
      partnerid: ConfigManager.getConfig(ConfigurationTypes.RELAX_SERVER).partnerId,
      clientid: GameModel.urlParams.clientid || "",
      immediatePayouts: false,
      acceptFreespinsMidsession: true,
    };

    ConsoleUtil.log("[SBRequests] Login request:", requestParams);

    return requestParams;
  }
}

export class SBoFunLoginRequest implements IRequestBuilder {
  get method() {
    return "POST";
  }

  get path() {
    if (GameModel.urlParams?.currency) {
      return ConfigManager.getConfig<IVendorClientConfigRequestData>(ConfigurationTypes.GAME).clientConfig.gameServerApi + "/demormlogin";
    } else {
      return ConfigManager.getConfig<IVendorClientConfigRequestData>(ConfigurationTypes.GAME).clientConfig.gameServerApi + "/funmoneylogin";
    }
  }

  get requestData() {
    return {
      g: ConfigManager.getConfig(ConfigurationTypes.RELAX_SERVER).gameId,
      channel: GameModel.urlParams.channel,
      currency: GameModel.currency || "EUR",
      partnerid: ConfigManager.getConfig(ConfigurationTypes.RELAX_SERVER).partnerId,
      jurisdiction: GameModel.urlParams.jurisdiction
    };
  }
}

export class BBTokenRequest implements IRequestBuilder {
  get method() {
    return "POST";
  }

  get path() {
    return ConfigManager.getConfig<IVendorClientConfigRequestData>(ConfigurationTypes.GAME).clientConfig.tokenApi;
  }

  get requestData() {
    let props = {
      ticket: GameModel.urlParams.ticket,
      partnerid: ConfigManager.getConfig(ConfigurationTypes.RELAX_SERVER).partnerId,
      channel: GameModel.urlParams.channel || "web",
      mode: GameModel.mode,
      gameref: ConfigManager.getConfig(ConfigurationTypes.RELAX_SERVER).gameId,
      clientid: GameModel.urlParams.clientid || "",
      currency: "",
    };

    ConsoleUtil.log("[SBRequests] Token request:", props);

    return props;
  }
}

/**
 * Used to get recovery(resume) data from server. Currently refresh data is being send when the login is made.
 * Maybe this is used somewhere else ?
 */
export class BBRefreshRequest implements IRequestBuilder {
  get method() {
    return "POST";
  }

  get path() {
    return ConfigManager.getConfig<IVendorClientConfigRequestData>(ConfigurationTypes.GAME).clientConfig.gameServerApi + "/refresh";
  }

  get requestData() {
    return {
      g: ConfigManager.getConfig(ConfigurationTypes.RELAX_SERVER).gameId,
      sid: GameModel.sessionID,
    };
  }
}

export class BBPlayRequest implements IRequestBuilder {
  get method() {
    return "POST";
  }

  get path() {
    return ConfigManager.getConfig<IVendorClientConfigRequestData>(ConfigurationTypes.GAME).clientConfig.gameServerApi + "/play";
  }

  get requestData() {
    let forcedOutcome;
    let response;
    if (DEBUG && debugModel.debugData) {
      if (!debugModel.special) {
        forcedOutcome = debugModel.debugData;
      }
      debugModel.cleanUp();
    }
    let lastRestoreVersion = GameModel.restoreVersion;
    GameModel.incrementRestoreVersion();
    let index =
      SpinModel.currentGeneration && SpinModel.generations
        ? SpinModel.generations[SpinModel.currentGeneration].index
        : 0;
    let state = JSON.stringify({
      generation: index,
      roundFinished: SpinModel.roundFinish,
      restoreVersion: GameModel.restoreVersion,
    });

    if (!VendorModel.inFreeGames) {
      if (GameModel.gameConfig.featureBye && BuyFeatureModel.hasBuyFeatureIsTriggered) {
        return {
          sid: GameModel.sessionID,
          g: ConfigManager.getConfig(ConfigurationTypes.RELAX_SERVER).gameId,
          ga: "spin", // gameAction
          ba: BuyFeatureModel.getTotalBet(), // betAmount
          forcedOutcome,
          response,
          restoreState: state,
          restoreVersion: lastRestoreVersion,
          buyFeature: true
        };
      } else {
        return {
          sid: GameModel.sessionID,
          g: ConfigManager.getConfig(ConfigurationTypes.RELAX_SERVER).gameId,
          ga: "spin", // gameAction
          ba: BetModel.totalBet, // betAmount
          forcedOutcome,
          response,
          restoreState: state,
          restoreVersion: lastRestoreVersion,
        };
      }

    } else {
      return {
        sid: GameModel.sessionID,
        g: ConfigManager.getConfig(ConfigurationTypes.RELAX_SERVER).gameId,
        ga: "spin", // gameAction
        ba: VendorModel.freeGames.ba,
        restoreState: state,
        restoreVersion: lastRestoreVersion,
        expectFreeRounds: true
        // restoreState : restoreState, //unknown usage. "SpinStart" is used in other client basegamecontroller
        // restoreVersion : restoreVersion //unknown usage
      };
    }
  }
}

export class BBScenarioRequest implements IRequestBuilder {
  get method() {
    return "POST";
  }

  get path() {
    return ConfigManager.getConfig<IVendorClientConfigRequestData>(ConfigurationTypes.GAME).clientConfig.gameServerApi + "/setnextresponse";
  }

  get requestData() {
    const response = debugModel.debugData;
    debugModel.cleanUp();
    return {
      sid: GameModel.sessionID,
      url: "/play",
      ga: "spin",
      response,
    };
  }
}
